import React from 'react';
import { observer } from 'mobx-react';
import ContactsVM from '../ContactsVM';
import { Neo } from '@singularsystems/neo-react';
import Contact from '../../../Models/Contacts/Contact';
import { Model } from '@singularsystems/neo-core';
import { Catalogue } from '@singularsystems/neo-react-services';
import TitleCatalogueEntry from '../../Catalogue/GenericComponents/TitleCatalogueEntry';
import ContactLookup from "../../../Models/Contacts/ContactLookup";
import ContactTypeCatalogueEntry from "../../Catalogue/General/ContactTypeCatalogueEntry";

interface IContactsEditModalProps {
    viewModel: ContactsVM;
    bindDisplay?: Model.IPropertyInstance<string | null>;
    bind?: Model.IPropertyInstance<number | null>;
    onSaved?: (contact?: ContactLookup) => void;
    showContactType?: boolean;
}

@observer
export default class ContactsEditModal extends React.Component<IContactsEditModalProps> {

    constructor(props: IContactsEditModalProps) {
        super(props);
    }

    public render() {
    const { viewModel, bindDisplay, bind, onSaved, showContactType} = this.props;

        return (
            <div>
                <Neo.Modal
                    title="Contact"
                    size="lg"
                    bindModel={viewModel.meta.editItem}
                    acceptButton={{ text: "Save", icon: "save", onClick: () => viewModel.saveContact(bind, bindDisplay, onSaved) }}>
                    {(item: Contact) => (
                        <Neo.GridLayout>
                            <div>
                                {showContactType &&
                                    <Catalogue.FormGroupInline bind={item.meta.contactTypeId} catalogueType={ContactTypeCatalogueEntry} />}
                                <Catalogue.FormGroupInline bind={item.values.meta.titleId} catalogueType={TitleCatalogueEntry} />
                                <Neo.FormGroupInline bind={item.values.meta.firstName} />
                                <Neo.FormGroupInline bind={item.values.meta.lastName} />
                                <Neo.FormGroupInline bind={item.values.meta.emailAddress} />
                            </div>
                            <div>
                                <Neo.FormGroupInline bind={item.values.meta.phoneNo} />
                                <Neo.FormGroupInline bind={item.values.meta.secondaryPhoneNo} />
                            </div>
                            <Neo.FormGroupInline bind={item.meta.postalAddress} input={{ rows: 3 }} />
                            <Neo.FormGroupInline bind={item.meta.physicalAddress} input={{ rows: 3 }} />
                        </Neo.GridLayout>
                    )}
                </Neo.Modal>
            </div>
        );
    }
}